const choices = {
    middleSchool: 'Collège',
    highSchool: 'Lycée',
    higherEducation: 'Enseignement supérieur',
};

export default choices;
